import SearchIcon from '@mui/icons-material/Search';
import {
  Checkbox,
  Divider,
  FormControlLabel,
  InputAdornment,
  Popover,
  Typography,
} from '@mui/material';
import redcheckbox from 'assets/images/redcheckbox.svg';
import CustomInput from 'components/CustomInput/customInput';
import { Loader } from 'components/loader';
// import debouce from 'lodash.debounce';
import React from 'react';
// import { toast } from 'react-toastify';
import { getAllListData } from 'services/CommonServices';
import { SkillType } from 'types';
import { MASTER_ENDPOINT } from 'utils/Constant';
import { SkillInfo, SkillReponse } from 'utils/type';

type Props = {
  selectSkill: Array<SkillType>;
  setSelectSkill: (src: SkillType[]) => void;
  anchorEl: null | HTMLElement;
  setAnchorEl: (src: null | any) => void;
  id: string;
  addSkills: () => void;
};
export const SkillMenu: React.FC<Props> = (props: Props) => {
  const { setSelectSkill, selectSkill, anchorEl, setAnchorEl, id, addSkills } =
    props;

  const [loading, setLoading] = React.useState(false);
  const [skillList, setSkillList] = React.useState<Array<SkillInfo>>([]);
  const [searchValue, setSearchValue] = React.useState<string>('');
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (e) => {
    const rawText = e.target.value;

    const trimmedText = String(rawText.trimStart());

    if (
      trimmedText === '' ||
      /^\s*$/.test(trimmedText) ||
      /[^a-zA-Z0-9\s]/.test(trimmedText)
    ) {
      setSearchValue(trimmedText);
    } else {
      setSearchValue(trimmedText);
    }
  };

  const getSkillList = (str: string) => {
    getAllListData(
      MASTER_ENDPOINT.Skills +
        '?sortby=name&order=asc&status=true&primary=true&skip=0&take=100&search=' +
        encodeURIComponent(str),
    )
      .then((resp: SkillReponse) => {
        setLoading(false);
        const capitalizedArrayOfStrings = resp.data.map((e) => ({
          ...e,
          name: e.name.charAt(0)?.toUpperCase() + e.name.slice(1),
        }));
        setSkillList([...capitalizedArrayOfStrings]);
      })
      .catch(() => {
        setSkillList([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  React.useEffect(() => {
    setLoading(true);
    // getSkillList(searchValue);
    setTimeout(() => {
      getSkillList(searchValue);
    }, 600);
  }, [searchValue]);
  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        horizontal: 'right',
        vertical: 'bottom',
      }}
      transformOrigin={{
        horizontal: 'right',
        vertical: 'top',
      }}>
      <Typography component={'div'} className="skil-popup">
        <CustomInput
          className="custom-search skill-search postition-sticky top-0"
          placeHolder="Select Skills"
          // onChange={debouncedResults}
          onChange={(e) => handleChange(e)}
          value={searchValue}
          type="search"
          inputProps={{
            endAdornment: (
              <InputAdornment position="end" className="icon-postition">
                <SearchIcon className="red-color" />
              </InputAdornment>
            ),
          }}
        />
        <Divider className="postition-sticky top-45" />
        <Typography component={'div'} className="skill-list-height">
          {loading ? (
            <Loader
              pageCenterLoadingHide={true}
              className={'d-flex-ja w-100 h-100'}
            />
          ) : skillList.length ? (
            skillList.map((e) => (
              <Typography component={'div'} key={e.id}>
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{ marginLeft: '2px !important' }}
                      checkedIcon={<img src={redcheckbox} alt="redcheck" />}
                      checked={selectSkill.some((ids) => ids.id === e.id)}
                      value={e?.id}
                      onChange={(el) => {
                        if (el?.target?.checked) {
                          setSelectSkill([
                            ...selectSkill,
                            { id: e.id, name: e.name, rowId: e.id },
                          ]);
                        } else {
                          setSelectSkill([
                            ...selectSkill.filter(
                              (existId) => existId.rowId !== e?.id,
                            ),
                          ]);
                        }
                      }}
                    />
                  }
                  label={e.name}
                />
              </Typography>
            ))
          ) : (
            <Typography
              component={'div'}
              className={'d-flex-ja w-100 h-100 red-color'}>
              No Records Found
            </Typography>
          )}
        </Typography>

        <Typography
          component={'div'}
          className="text-center bottom-0 postition-sticky">
          <Divider />
          <Typography
            component={'button'}
            type={'button'}
            className={`rec-add-btn ad-btn-notes don-btn mt-8 mb-8 ${
              selectSkill.length === 0 ? 'disabled-skill-add-btn' : ''
            }`}
            onClick={() => {
              if (selectSkill.length) {
                addSkills();
                handleClose();
                // toast.success('Skills added successfully');
              }
            }}
            style={{
              cursor: selectSkill.length === 0 ? 'not-allowed' : 'pointer',
              opacity: selectSkill.length === 0 ? 0.5 : 1,
            }}>
            Add
          </Typography>
        </Typography>
      </Typography>
    </Popover>
  );
};
